<div class="main px-5">
  <div class="row mt-4">
    <div class="col-12 mt-3 py-2 px-5 bg-light-color">
      <div class="col-12 d-flex mt-3 justify-content">
        <div class="titulo">
          <h3 class="fw-bold text-primary-color my-3">
            Editar Parametrização - <span>{{ titulo }}</span>
          </h3>
        </div>

      </div>

      <div class="col-12">
        <form [formGroup]="parametrizacaoForm" id="parametrizacaoForm" #formElement (ngSubmit)="submit()">
          <div class="row g-2">
            <div class="col-12 form-group">
              <label for="nome" class="form-label required">Nome</label>
              <nz-input-group nzSize="large">
                <input nz-input id="nome" formControlName="nome" placeholder="Nome" />
              </nz-input-group>
            </div>
            <div class="col-12 form-group">
              <label for="descricao" class="form-label">Descrição</label>
              <nz-input-group nzSize="large">
                <input nz-input id="descricao" formControlName="descricao" placeholder="Descrição" />
              </nz-input-group>
            </div>
            <div class="col-12 form-group">
              <label for="value" class="form-label required">Valor</label>
              <nz-input-group nzSize="large">
                <input nz-input id="value" formControlName="value" placeholder="Valor" />
              </nz-input-group>
            </div>

          </div>
          <nz-divider></nz-divider>
          <div class="row mb-4">
            <div class="d-flex justify-content-between">
              <div class="col">
                <button nz-button nzType="default" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button" (click)="voltar()">
                  Voltar
                  <span class="fs-3 ms-2 mdi--search"></span>
                </button>
              </div>
              <div class="col d-flex justify-content-end">
                <button nz-button nzType="primary" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="submit">
                  {{ inserir ? 'Salvar Parametrização' : 'Editar Parametrização' }}
                  <span class="fs-3 ms-2 mdi--search"></span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
